document.addEventListener("DOMContentLoaded", function() {

    scrollAppearance();

    window.addEventListener("resize", () => {
        scrollAppearance();
    })

});

export default function scrollAppearance(){

    const wrapper = document.querySelectorAll(".js-scrollbar-wrap");

    if(wrapper.length > 0){

        wrapper.forEach(function(el){

            const item = el.querySelector(".js-scrollbar"),
                mainWrap = el.closest(".js-scroll-wrap");

            let scrollbarHeight = mainWrap.clientHeight - item.clientHeight;

            mainWrap.style.setProperty("--scrollbar-height", scrollbarHeight);

            if (el.clientWidth < item.scrollWidth) {
                mainWrap.classList.add("scrollbar");
            } else {
                mainWrap.classList.remove("scrollbar");
            }
        });
    }

}